import React, { useState } from 'react';
import {
  Box,
  MenuItem,
  InputAdornment,
  TextField,
  Grid,
  FormControl,
  Autocomplete,
  IconButton,
  Typography,
  Divider,
  Tooltip,
  useMediaQuery,
} from '@mui/material';
import { CloseOutlined, SearchOutlined } from '@mui/icons-material';
import CustomTextField from '../../../common/Form/TextField';
import { useTheme } from '@emotion/react';

const SearchAndFilter = ({
  searchTerm,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  selectedCountry,
  selectedRegions,
  handleCountryChange,
  handleRegionChange,
}) => {
  const regions = {
    India: ['Ahmedabad', 'Pune', 'Vadodara', 'Rajkot'],
    'The Netherlands': ['Amsterdam', 'Rotterdam', 'The Hague'],
    Canada: ['Toronto', 'Vancouver', 'Montreal'],
    USA: ['New York', 'Los Angeles', 'Chicago'],
    'South Africa': ['Johannesburg', 'Cape Town', 'Durban'],
    UAE: ['Dubai', 'Abu Dhabi', 'Sharjah'],
    UK: ['London', 'Manchester', 'Birmingham'],
    Belgium: ['Brussels', 'Antwerp', 'Ghent'],
    Denmark: ['Copenhagen', 'Aarhus', 'Odense'],
    Finland: ['Helsinki', 'Tampere', 'Turku'],
    France: ['Paris', 'Lyon', 'Marseille'],
    Germany: ['Berlin', 'Munich', 'Frankfurt'],
    Iceland: ['Reykjavik', 'Akureyri', 'Hafnarfjordur'],
    Norway: ['Oslo', 'Bergen', 'Stavanger'],
    Sweden: ['Stockholm', 'Gothenburg', 'Malmo'],
  };

  const countries = Object.keys(regions);
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchTermBar, setSearchTermBar] = useState('');

  const handleSearchClick = () => {
    setSearchVisible(!searchVisible);
  };

  const handleSearchChange = (event) => {
    setSearchTermBar(event.target.value);
  };
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center',height:isSm&&"25px" }}>
      {!isSm ? (
        <Divider orientation='vertical' flexItem sx={{ mx: 2, mt: 1, mb: 1 }} />
      ) : (
        <Divider orientation='horizontal' sx={{ flex: 1  }} />
      )}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          float: 'right',
          ml: 'auto',
        }}
      >
        {isXl ? <Typography sx={{ color: 'grey', fontSize: '14px' }}>Sort by:</Typography> : null}
        {/* {searchVisible ? (
          <></>
        ) : (
          <IconButton size="large" onClick={handleSearchClick} sx={{ ml: 0.6, mr: 0, padding: 0 }}>
            <SearchOutlined sx={{ color: 'grey', fontSize: '18px' }} />
          </IconButton>
        )} */}
        {/* <Divider orientation='horizontal' sx={{ width: '60vw' }} /> */}
        <Typography sx={{ color: 'grey', fontSize: '14px' }}>Filter by:</Typography>
        <TextField
          select
          variant='outlined'
          size='small'
          value={selectedCategory}
          onChange={onCategoryChange}
          sx={{
            width: 'auto',
            // maxWidth: isSm ? '25vw' : '10vw',
            backgroundColor: 'transparent',
            '& .MuiOutlinedInput-root': {
              border: 'none',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '& .MuiInputBase-input': {
              fontSize: '14px',
              // fontWeight: 'bold',
            },
          }}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: {
                  maxHeight: 500, // Set the maximum height of the dropdown
                  overflowY: 'auto', // Enable vertical scrolling
                },
              },
            },
          }}
        >
          <MenuItem value='All'>All</MenuItem>
          <MenuItem value='My Posts'>My Posts</MenuItem>
          <MenuItem value='Public news'>Public news</MenuItem>
          <MenuItem value='Internal Posts'>Internal Posts</MenuItem>
          <MenuItem value='Events'>Events</MenuItem>
          <MenuItem value='Summer extravaganza'>Summer extravaganza</MenuItem>
          <MenuItem value='GPL 2025'>GPL 2025</MenuItem>
          <MenuItem value='GPL 2024'>GPL 2024</MenuItem>
          <MenuItem value='GPL 2023'>GPL 2023</MenuItem>
          <MenuItem value='R&R'>R&R</MenuItem>
          <MenuItem value='GIFT'>GIFT</MenuItem>
          <MenuItem value='Foundation'>Foundation</MenuItem>
          <MenuItem value='New Joinee'>New Joinee</MenuItem>
          <MenuItem value='Celebrations'>Celebrations</MenuItem>
          <MenuItem value='Business'>Business</MenuItem>
          <MenuItem value='Corporate'>Corporate</MenuItem>
          <MenuItem value='Achievements'>Achievements</MenuItem>
          <MenuItem value='Team@Gateway'>Team@Gateway</MenuItem>
          <MenuItem value='Awards and Recognition'>Awards and Recognition</MenuItem>
          <MenuItem value='Tech@Gateway'>Tech@Gateway</MenuItem>
          <MenuItem value='Fun Friday'>Fun Friday</MenuItem>
          <MenuItem value='Growth Story'>Growth Story</MenuItem>
          <MenuItem value='Milestone'>Milestone</MenuItem>
          <MenuItem value='Sports Tournaments'>Sports Tournaments</MenuItem>
        </TextField>
      </Box>
    </Box>
  );
};

export default SearchAndFilter;
